module.exports = __webpack_public_path__ + "static/site-preview-ffc606ae4af9b566a64053740a0f9315.jpg";